import { render, staticRenderFns } from "./Add-Update-Product.vue?vue&type=template&id=08dabe90&scoped=true&"
import script from "./Add-Update-Product.vue?vue&type=script&lang=js&"
export * from "./Add-Update-Product.vue?vue&type=script&lang=js&"
import style0 from "./Add-Update-Product.vue?vue&type=style&index=0&id=08dabe90&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dabe90",
  null
  
)

export default component.exports